import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aum-cli-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.scss']
})
export class UnderConstructionComponent {
  constructor(public dialogRef: MatDialogRef<UnderConstructionComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
